module.exports = __webpack_public_path__ + "static/media/thumb-aluminio.1945ca30.png";